<template>
  <v-card>
    <v-snackbar top :timeout="5000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card-title class="headline">
      <h5>Seleccionar hora de entrega</h5>
      <v-btn
        style="right: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="mb-0 pb-0">
      <v-container fluid>
        <v-checkbox
          class="mt-0 ML-5"
          v-model="soon"
          label="Lo antes posible"
        ></v-checkbox>
        <v-row class="mb-0 pb-0">
          <v-col cols="12" sm="12" md="12">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Seleccionar fecha de entrega"
                  persistent-hint
                  rounded
                  filled
                  :disabled="soon"
                  v-bind="attrs"
                  hide-details
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                :max="max"
                :disabled="soon"
                :min="min"
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-menu
              ref="menu"
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="time"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  rounded
                  filled
                  v-model="time"
                  label="Seleccionar hora"
                  hide-details
                  :disabled="soon"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menu2"
                v-model="time"
                min="07:30"
                max="21:00"
                ampm-in-title
                :allowed-hours="allowedHours"
                :allowed-minutes="allowedMinutes"
                full-width
                :disabled="soon"
                @click:minute="$refs.menu.save(time)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-btn
        block
        rounded
        color="primary"
        class="mb-2"
        height="50"
        @click="next"
        >Seleccionar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

export default {
  name: "time-picker",
  props: ["timeData"],
  data() {
    return {
      selectedMinute: null,
      soon: true,
      selectedHour: null,
      currentMinute: "",
      currentHour: "",
      snackbarText: "",
      snackbar: false,
      menu2: false,
      time: null,
      date: moment()
        .tz("America/Tegucigalpa")
        .subtract(6, "hours")
        .toISOString()
        .substr(0, 10),
      max: moment()
        .tz("America/Tegucigalpa")
        .subtract(6, "hours")
        .add(3, "days")
        .toISOString()
        .substr(0, 10),
      min: moment()
        .tz("America/Tegucigalpa")
        .subtract(6, "hours")
        .toISOString()
        .substr(0, 10),
      menu: false,
    };
  },

  // computed: {
  //   getMinutes() {
  //     if (this.hours[this.selectedHour] == this.currentHour) {
  //       return this.minutes.filter(
  //         (i) => Number(i) >= Number(this.currentMinute) + 30
  //       );
  //     } else {
  //       return this.minutes;
  //     }
  //   },
  // },

  methods: {
    allowedHours(h) {
      let now = moment();

      let date = `${this.date} ${h}:00`;
      let date2 = `${this.date} ${h}:30`;

      let selectedDate = moment(date, "YYYY-MM-DD hh:mm");
      let selectedDate2 = moment(date2, "YYYY-MM-DD hh:mm");

      let diff1 = Number(selectedDate.diff(now, "minutes"));
      let diff2 = Number(selectedDate2.diff(now, "minutes"));

      return diff1 > 30 || diff2 > 30;
    },

    allowedMinutes(m) {
      let now = moment();
      let hour = this.time.split(":")[0];
      let time = `${this.date} ${hour}:${m}`;

      let selectedDate = moment(time, "YYYY-MM-DD hh:mm");

      let diff = Number(selectedDate.diff(now, "minutes"));

      return m % 30 === 0 && diff > 30;
    },

    next() {
      if (!this.soon) {
        if (!this.time || !this.date) {
          this.snackbarText = "Seleccione la fecha y hora de inicio.";
          this.snackbar = true;
          return;
        }
      }

      this.$emit("success", {
        soon: this.soon,
        time: this.time,
        date: this.date,
      });
    },
  },

  mounted() {
    let availableDate = moment().add(40, "minutes");

    if (this.timeData && this.timeData.time && this.timeData.date) {
      availableDate = moment(
        `${this.timeData.date} ${this.timeData.time}`,
        "YYYY-MM-DD hh:mm"
      );
    } else {
      let m = availableDate.format("mm");

      if (m > 30) {
        availableDate.add(1, "hour").set("minute", 0);
      } else {
        availableDate.set("minute", 30);
      }
    }

    this.soon = this.timeData.soon;
    this.date = availableDate.format("YYYY-MM-DD");

    this.time = availableDate.format("HH:mm");
    console.log(this.time);
  },
};
</script>


<style scoped>
.list-c {
  max-height: 300px;
  overflow: auto;
}

/* width */
.list-c::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.list-c::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
.list-c::-webkit-scrollbar-thumb {
  background: rgb(176, 176, 176);
  border-radius: 10px;
}
</style>